import { render, staticRenderFns } from "./SunburstWidget.vue?vue&type=template&id=767c4544&scoped=true"
import script from "./SunburstWidget.vue?vue&type=script&lang=js"
export * from "./SunburstWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c4544",
  null
  
)

export default component.exports